export const SAVE_USER_PROFILE_ERROR = 'Updated error!'
export const SAVE_USER_PROFILE_SUCCESS = 'Updated successfully!'
export const DISCARD_USER_PROFILE_ERROR = 'Discard error!'
export const SAVE_UPDATE_ROLE_SUCCESS = 'Changed Role successfully!'
export const SAVE_UPDATE_ROLE_ERROR = 'Changed Role error!'
export const RESET_PASSWORD_USER_SUCCESS = 'Reset password successfully!'
export const RESET_PASSWORD_USER_ERROR = 'Reset password error!'
export const ELIMINATE_USER_SUCCESS = 'Eliminated user successfully!'
export const ELIMINATE_USER_ERROR = 'Eliminated user error!'